module.exports = __webpack_public_path__ + "img/img1.714a216c.svg";